import { jsx } from 'react/jsx-runtime';
import { DatePickerCore } from '../DatePicker.Core/DatePicker.Core.es.js';

const DatePickerRange = ({ onChange, ...props })=>{
    return jsx(DatePickerCore, {
        onRangeChange: onChange,
        ...props,
        selectsRange: true
    });
};

export { DatePickerRange };
//# sourceMappingURL=DatePicker.Range.es.js.map
